import * as React from "react";
import styled, { css } from "styled-components";
import { IconButton } from "components/common";
import zIndices from "theme/z-indices";
export const Container = styled.div(
  ({ theme, $sidebarIsPinned, $width }) => css`
    position: ${$sidebarIsPinned ? "relative" : "fixed"};
    width: ${$width}px;
    height: ${$sidebarIsPinned ? "100%" : "calc(100% - 50px)"}; /* subtract the nav height */
    top: ${$sidebarIsPinned ? 0 : "50px"};
    left: ${$sidebarIsPinned ? 0 : "50px"};

    background: ${theme.colors.global.contentBackground};
    border-right: ${$sidebarIsPinned ? "none" : `1px solid ${theme.colors.variant.light.default}`};
    box-shadow: ${$sidebarIsPinned ? `3px 3px 3px ${theme.colors.global.navigationBoxShadow}` : "none"};
    z-index: ${zIndices.sidebar};

    ${$sidebarIsPinned && css`
      &::before {
        content: '';
        position: absolute;
        top: 0;
        right: -6px;
        height: 6px;
        width: 6px;
        border-top-left-radius: 50%;
        background: transparent;
        box-shadow: -6px -6px 0 3px ${theme.colors.global.contentBackground};
      }
    `}
  `
);
const ContentGrid = styled.div(
  ({ theme }) => css`
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: auto minmax(1px, 1fr);
    height: 100%;
    overflow-y: auto;

    padding: 5px 15px 0;

    color: ${theme.colors.text.primary};
  `
);
const Header = styled.div`
  grid-column: 1;
  grid-row: 1;
`;
const TitleSection = styled.div`
  height: 35px;
  display: grid;
  grid-template-columns: 1fr auto;

  > *:nth-child(1) {
    grid-column: 1;
  }

  > *:nth-child(2) {
    grid-column: 2;
  }
`;
const Title = styled.h1`
  color: inherit;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  cursor: pointer;
`;
const OverlayToggle = styled.div(
  ({ theme, $sidebarIsPinned }) => css`
    > * {
      font-size: ${theme.fonts.size.large};
      color: ${$sidebarIsPinned ? theme.colors.variant.info : theme.colors.gray[30]};
    }
  `
);
const HorizontalRule = styled.hr`
  margin: 5px 0 10px;
`;
const SectionTitle = styled.h2`
  margin-bottom: 10px;
`;
const CenterVertical = styled.div`
  display: inline-grid;
  align-content: center;
`;
const SectionContent = styled.div`
  grid-column: 1;
  grid-row: 2;

  /* Fixes padding problem with padding-bottom from container */
  > *:last-child {
    padding-bottom: 15px;
  }
`;
const toggleSidebarPinning = (searchPageLayout) => {
  if (!searchPageLayout) {
    return;
  }
  const {
    actions: { toggleSidebarPinning: togglePinning }
  } = searchPageLayout;
  togglePinning();
};
const DefaultTitle = ({ onClose, children = null }) => /* @__PURE__ */ React.createElement(Title, { onClick: onClose }, children);
const ContentColumn = ({
  children,
  title,
  sectionTitle,
  closeSidebar,
  searchPreferencesLayout,
  forceSideBarPinned,
  enableSidebarPinning,
  width = 275
}) => {
  const sidebarIsPinned = (searchPreferencesLayout == null ? void 0 : searchPreferencesLayout.config.sidebar.isPinned) || forceSideBarPinned;
  const titleAttr = typeof title === "string" ? title : void 0;
  const TitleComponent = typeof title === "string" ? DefaultTitle : title;
  return /* @__PURE__ */ React.createElement(Container, { $sidebarIsPinned: sidebarIsPinned, $width: width }, /* @__PURE__ */ React.createElement(ContentGrid, null, /* @__PURE__ */ React.createElement(Header, null, /* @__PURE__ */ React.createElement(TitleSection, { title: titleAttr }, /* @__PURE__ */ React.createElement(CenterVertical, null, /* @__PURE__ */ React.createElement(TitleComponent, { onClose: closeSidebar }, typeof title === "string" ? title : null)), !forceSideBarPinned && enableSidebarPinning && /* @__PURE__ */ React.createElement(CenterVertical, null, /* @__PURE__ */ React.createElement(OverlayToggle, { $sidebarIsPinned: sidebarIsPinned }, /* @__PURE__ */ React.createElement(
    IconButton,
    {
      onClick: () => toggleSidebarPinning(searchPreferencesLayout),
      title: `Display sidebar ${sidebarIsPinned ? "as overlay" : "inline"}`,
      name: "keep"
    }
  )))), /* @__PURE__ */ React.createElement(HorizontalRule, null), /* @__PURE__ */ React.createElement(SectionTitle, null, sectionTitle)), /* @__PURE__ */ React.createElement(SectionContent, null, children)));
};
export default ContentColumn;
